<template>
  <div class="">
    <div class="top-search-box" style="background:#fff">
      <topTab :rout="rout"></topTab>
      <div class="head-top">
        <div class="search-box">
          <input type="text" placeholder="请输入梦境关键词" v-model="keyword" />
          <div class="search-btn" @click="result">开始解梦</div>
        </div>
      </div>
    </div>
    <div class="content">
      
      <!-- <div style="height: 1.3rem"></div> -->
      <div class="ps">与 {{ keyword }} 相关的周公解梦</div>
      <div>
        <ul>
          <list
            v-model="loading"
            :finished="finished"
            finished-text=""
            @load="onLoad"
          >
            <li
              v-for="(item, index) in list"
              :key="index"
              @click="jump_details(item)"
            >
              <div>
                <p class="title">{{ item.title }}</p>
                <p class="text">{{ delHtmlTag(item.content) }}</p>
              </div>
              <i class="iconfont icon-a-LeftArrow"></i>
            </li>
          </list>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:搜索结果
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";

import { List } from "vant";
export default {
  name: "",
  props: {},
  components: { List ,topTab},
  data() {
    return {
      loading: false,
      finished: true,
      keyword: "",
      list: [],
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'周公解梦',
        path:'/zgjm'
      },{
        name:'周公解梦',
      }]
    };
  },
  computed: {
    delHtmlTag() {
      return function (str) {
        return str.replace(/<[^>]+>/g, "").trim();
      };
    },
  },
  watch: {},
  mounted() {},
  created() {
    if (this.$route.query && this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
      this.result();
    }
  },
  methods: {
    onLoad() {},
    result() {
      if (this.keyword === "") return this.Toast("请輸入关键字");
      this.api.oneiromancy({ keyword: this.keyword }).then((res) => {
        this.list = res.data;
      });
    },
    jump_details(item) {
      localStorage.setItem("result", JSON.stringify(item));
      this.$router.push("jmdetails");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.head-top {
  height: 1.3rem;
  background: white;
}
.search-box {
  margin-top: 0.2rem;
  width: 7rem;
  height: 1rem;
  background: #f0f0f0;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0 0.04rem;
  box-sizing: border-box;
  input {
    flex: 1;
    padding-left: 0.76rem;
    height: 100%;
    border: none;
    background: transparent;
  }
  .search-btn {
    width: 2.12rem;
    height: 0.88rem;
    border-radius: 0.44rem;
    background: #4fd9d5;
    font-size: 0.3rem;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.ps {
  font-size: 0.4rem;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin-bottom: 0.2rem;
  margin-top: 0.5rem;
}

ul {
  li {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    padding: 0.4rem 0 0.2rem;
    > div {
      flex: 1;
    }
    .title {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .text {
      width: 4.5rem;
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    i {
      color: #cccccc;
      font-size: 0.2rem;
    }
  }
}
</style>
